import axios from "axios";

export const getAuthToken = async (payload,apiUrl,sourceHeader) => { 
   const resp = await fetch(`${apiUrl}`, {
        method: "POST",
        headers: { "Content-Type": "application/json",
          "x-boons-source": `${sourceHeader}`
         },
        body: JSON.stringify(payload),
      });
      const responseData = await resp.json();
     return { tokenData: responseData.data };
};

export const getRefreshToken = async (payload,token,apiUrl,sourceHeader) => {
   const resp = await fetch(`${apiUrl}`, {
        method: "POST",
        headers: { "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
          "x-boons-source": `${sourceHeader}`
         },
        body: JSON.stringify(payload),
      });
      const responseData = await resp.json();
     return { refreshTokenData: responseData.data };
};

export const getRestaurantInfo = async (token,restaurantId,apiUrl,sourceHeader) => {
 
   const resp = await fetch(`${apiUrl}${restaurantId}/config`, {
        method: "GET",
        headers: { "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
        "x-boons-source": `${sourceHeader}`
         },
      });
      const responseData = await resp.json();
      // console.log("RESPONSE", responseData)
      return responseData.data ;
};
export const getRestaurantConfig = async (token,restaurantId,apiUrl,sourceHeader) => {
   const resp = await fetch(`${apiUrl}${restaurantId}/config`, {
        method: "GET",
        headers: { "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
        "x-boons-source": `${sourceHeader}`
         },
      });
      const responseData = await resp.json();
      // console.log("RESPONSE", responseData)
      return responseData.data ;
};
export const getConnectionToken = async (token,apiUrl,sourceHeader) => {
   const resp = await fetch(`${apiUrl}`, {
        method: "GET",
        headers: { "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
        "x-boons-source": `${sourceHeader}`
         },
      });
      const responseData = await resp.json();
      // console.log("RESPONSE", responseData)
      return responseData.data.secret ;
};
export const getPaymentIntent = async (payload,token,apiUrl,sourceHeader) => {
   const resp = await fetch(`${apiUrl}`, {
        method: "POST",
        headers: { "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
        "x-boons-source": `${sourceHeader}`
         },
        body: JSON.stringify(payload),
      });
      const responseData = await resp.json();
      // console.log("RESPONSE", responseData)
      return responseData.data ;
};
export const placeKioskOrder = async (payload,token,apiUrl,sourceHeader) => {
  return await axios.post(
    `${apiUrl}`,
    payload,
    {
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
        "x-boons-source": `${sourceHeader}`
      }
    }
  );
};



